import { render, staticRenderFns } from "./ListPlatforms.vue?vue&type=template&id=663de23a&"
import script from "./ListPlatforms.vue?vue&type=script&lang=js&"
export * from "./ListPlatforms.vue?vue&type=script&lang=js&"
import style0 from "./ListPlatforms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListPlatforms.vue"
export default component.exports